export default __webpack_public_path__ + "static/media/homepagemockup.82edb732.png";